import React from 'react';
import { LucideIcon } from 'lucide-react';

interface TimelineEvent {
  year: string;
  title: string;
  subtitle?: string;
  location?: string;
  icon?: LucideIcon;
}

interface TimelineProps {
  events: TimelineEvent[];
}

const Timeline: React.FC<TimelineProps> = ({ events }) => {
  return (
    <div className="relative">
      {/* Timeline Line */}
      <div className="absolute left-1/2 transform -translate-x-1/2 w-0.5 h-full bg-dark/20"></div>

      <div className="space-y-16">
        {events.map((event, index) => {
          const Icon = event.icon;
          return (
            <div
              key={index}
              className={`relative flex ${
                index % 2 === 0 ? 'justify-end md:justify-start' : 'justify-start md:justify-end'
              }`}
            >
              <div
                className={`w-full md:w-5/12 ${
                  index % 2 === 0 ? 'md:text-right md:pr-8' : 'md:text-left md:pl-8'
                }`}
              >
                <div className="bg-white rounded-xl shadow-lg p-6 transform hover:scale-105 transition-transform duration-300">
                  <div className="flex items-center justify-between mb-4">
                    <div className="bg-dark text-beige rounded-full px-4 py-2 text-sm font-bold">
                      {event.year}
                    </div>
                    {Icon && <Icon className="h-6 w-6 text-dark" />}
                  </div>
                  <h3 className="text-xl font-serif font-bold text-dark mb-2">{event.title}</h3>
                  {event.subtitle && (
                    <p className="text-dark/80">{event.subtitle}</p>
                  )}
                  {event.location && (
                    <p className="text-dark/60 text-sm mt-2">{event.location}</p>
                  )}
                </div>
              </div>
              {/* Timeline Dot */}
              <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-dark rounded-full border-4 border-beige"></div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Timeline;